import React from "react";
import { IoIosArrowForward, IoIosList, IoIosStats } from "react-icons/io";
import { FormatNumber } from "../../helpers";
import Skeleton from "@yisheng90/react-loading";
import LineChart from "./LineChart";
import "./summary-month.css";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
  "Jul", "Ags", "Sep", "Okt", "Nov", "Des",
];

export default function SummaryMonth(props) {
  const [isTable, setIsTable] = React.useState(true);
  const { wallet, loading } = props;

  const data = (props.data || []).map((d) => {
    const m = (d.year + d.month.toString().padStart(2, "0")) * 1;
    return { m, ...d };
  });

  const rowClass = (d) => {
    const net = (d.positive || 0) + (d.negative || 0);
    if (net < 0) return "is-negative";
    if (net > 0) return "is-positive";
    return "";
  };

  return (
    <div>
      <div className="summary-toolbar">
        <div
          className="summary-toggle"
          role="tablist"
          aria-label="Mode tampilan"
        >
          <button
            type="button"
            className={`summary-toggle__btn ${
              isTable ? "summary-toggle__btn--active" : ""
            }`}
            onClick={() => setIsTable(true)}
            aria-label="Tampilan tabel"
            aria-pressed={isTable}
          >
            <IoIosList />
          </button>
          <button
            type="button"
            className={`summary-toggle__btn ${
              !isTable ? "summary-toggle__btn--active" : ""
            }`}
            onClick={() => setIsTable(false)}
            aria-label="Tampilan grafik"
            aria-pressed={!isTable}
          >
            <IoIosStats />
          </button>
        </div>
        <button
          type="button"
          className="summary-wallet"
          onClick={props.onSelectWallet}
        >
          <span>{wallet ? wallet.name : "Semua wallet"}</span>
          <IoIosArrowForward />
        </button>
      </div>

      {isTable ? (
        <table className="summary-table">
          <thead>
            <tr>
              <th>Bulan</th>
              <th>Masuk</th>
              <th>Keluar</th>
              <th>Net</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? [...Array(5).keys()].map((i) => (
                  <tr key={i}>
                    <td colSpan="4">
                      <Skeleton width="100%" />
                    </td>
                  </tr>
                ))
              : data.map((d, i) => (
                  <tr key={i} className={rowClass(d)}>
                    <td>{`${MONTHS[d.month - 1]} ${d.year}`}</td>
                    <td>{FormatNumber(d.positive || 0)}</td>
                    <td>{FormatNumber(Math.abs(d.negative || 0))}</td>
                    <td>{FormatNumber((d.positive || 0) + (d.negative || 0))}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      ) : (
        <LineChart trx={data} months={MONTHS} />
      )}
    </div>
  );
}
